<template>
  <v-dialog
    retain-focus
    :value="edit"
    v-on:click:outside="goToShow"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Edit Customer</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            :rules="validationRules.name"
            v-model="editFields.name"
            label="Customer Name*"
            required
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveCustomer"
            ref="name"
            tabindex="0"
          />
          <v-text-field
            :rules="validationRules.address"
            v-model="editFields.address"
            label="Address"
            :error-messages="inputErrorMessages('address')"
            v-on:keyup.enter="saveCustomer"
            ref="address"
            tabindex="1"
          />
          <v-text-field
            :rules="validationRules.contact_numbers"
            v-model="editFields.contact_numbers"
            label="Contact Numbers"
            :error-messages="inputErrorMessages('contact_numbers')"
            v-on:keyup.enter="saveCustomer"
            ref="contact_numbers"
            tabindex="2"
          ></v-text-field>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveCustomer">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Customer name'),
          v => !v || v.length <= 255 || 'Customer name should not be greater than 255'
        ],
        address: [v => !v || v.length <= 255 || 'Address should not be greater than 255'],
        contact_numbers: [
          v => !v || v.length <= 255 || 'Contact numbers should not be greater than 255'
        ]
      },
      errorMessages: {},
      editFields: {
        name: '',
        address: '',
        contact_numbers: ''
      }
    };
  },
  computed: {
    ...mapState({
      customer(state) {
        if (typeof state.Customer.customer.data == 'undefined') {
          return {
            name: '',
            address: '',
            contact_numbers: ''
          };
        }
        return state.Customer.customer.data;
      }
    })
  },
  watch: {
    customer(value) {
      this.editFields.name = value.name;
      this.editFields.address = value.address;
      this.editFields.contact_numbers = value.contact_numbers;
    }
  },
  mounted() {
    this['Customer/getCustomer']({ id: this.$route.params.id });
    // this['Customer/getCustomer']({ id: this.$route.params.id }).finally(() => {
    //   this.editFields.name = this.$store.state.Customer.customer.name;
    //   this.editFields.address = this.$store.state.Customer.customer.address;
    //   this.editFields.contact_numbers = this.$store.state.Customer.customer.contact_numbers;
    // });
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions(['Customer/fetchCustomers', 'Customer/getCustomer']),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    rem(address) {
      return `${address} is required`;
    },
    rem(contact_numbers) {
      return `${contact_numbers} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveCustomer() {
      if (this.$refs.createForm.validate()) {
        axios
          .put(`api/v1/customer/${this.$route.params.id}`, this.editFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Customer saved...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['Customer/fetchCustomers']({ page: this.page });
            this.$router.push('/customer');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    goToShow() {
      this.$router.push(`/customer/${this.$route.params.id}`);
    }
  }
};
</script>